import React from "react";

import LogoUmbra from "../UI/Brand/Umbra3DST-white.svg";

import svg_loading from "../UI/oval.svg";
import icons from "../utils/import.icons";

import LogoProyecto from "./../UI/svg/logo-menu.svg";

import MapaComponent from "./ui/MapaComponent";
import GaleriaComponent from "./ui/GaleriaComponent";
import Recorrido360Component from "./ui/Recorrido360Component";

import CotizacionComponent from "./ui/CotizacionComponent";

import BarEtapasPisoComponent from "./etapas/BarEtapasComponent";
import BarAmenidadesComponent from "./amenidades/BarAmenidadesComponent";

import VideoComponent from "./ui/VideoComponent";

import {
  getProyecto,
  getDropboxFiles,
  createEmail,
  insertCotizacion,
} from "./../services/renders.dao";
import ImportHelper from "./../utils/import.helper";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { ContextLoader } from "./../utils/import.frames";

import Camera from "./camera/camera.component";
import Transicion from "./camera/transicion.component";
import Viewer360 from "./viewer360.component";
import { ContextTransitions } from "../utils/import.transits";
import Bubbles from "./overlay/bubbles.component";
import Billboards from "./overlay/billboards.component";

import GuidedTour from "../services/tour/Room";

import videosData from "./../videos/videos.json";

import {
  loadingCanva,
  waitingCanva,
  barHiddenCanva,
  isSideBarHomeCanva,
  isVisitaMapCanva,
  initialProyectosWelcome,
  showedMapCanva,
  selectedTorreCanva,
  selectedAptoTipoCanva,
  selectedNumeroAptoCanva,
  indexAptoTipoCanva,
  tiposAptosCotizadosCanva,
  selectedAptosCanva,
  selectedFloorCanva,
  aptotipoOpenedCanva,
  openGaleriaCanva,
  open360Canva,
  selectedPOICanva,
  isFormCotizacionCanva,
  linksCanva,
  linkTransitionCanva,
  isTransicionCanva,
  initFramePOICanva,
  isPreTransitionCanva,
  aptosCotizadosCanva,
  is180Canva,
  showGeneralViewCanva,
  isImage360Canva,
  showBubblesCanva,
  showBillboardsCanva,
  categoryFilterCanva,
  torreFilterCanva,
  aptoFilterCanva,
  amenityCanva,
  showingTorresSpinCanva,
  towerTransitionCanva,
  rotateForBubbleCanva,
  selectedZonaInteresCanva,
  mainCameraAngleCanva,
  btnSelectedCanva,
  isAmenidadesCanva,
  isEtapasCanva,
  isZonasInteresCanva,
  isViasCanva,
  selectedAptoCanva,
  initFrame180Canva,
  bubbleAngleCanva,
  cameraAngleCanva,
  animateCanva,
  isPlanoCanva,
  btnSelected2Canva,
  hasVideoCanva,
  openVideoCanva,
  currentVideoCanva,
  fullUpdate,
} from "../redux/actions";
import MenuGeneralContainer from "../container/menuGeneralContainer";

class Canvas extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      //animate: false,
      lockedControl: false,
      hasControl: true,
      zoom: 1,
      //hasVideo: false,
      //openVideo: false
    };

    this.bubblesRef = React.createRef();
    this.mainCameraRef = React.createRef();
    this.secondaryCameraRef = React.createRef();
    this.galleryRef = React.createRef();
    this.mapRef = null;
    this.viewer360ref = React.createRef();
  }

  componentDidMount() {
    this.towerBubbleAngles = {
      "Torre 1": {
        "Tipo A": 5,
        "Tipo B": 0,
        "Tipo C": 130,
        "Tipo D": 100,
        "Tipo E": 85,
        "Tipo F": 80,
        "Tipo G": 60,
        "Tipo H": 10,
      },
      "Torre 2": {
        "Tipo A": 50,
        "Tipo B": 40,
        "Tipo C": 140,
        "Tipo D": 115,
        "Tipo E": 105,
        "Tipo F": 85,
      },
      "Torre 3": {
        "Tipo A": 115,
        "Tipo B": 40,
        "Tipo C": 85,
        "Tipo D": 50,
        "Tipo E": 105,
        "Tipo F": 140,
      },
      "Torre 4": {
        "Tipo A": 80,
        "Tipo B": 75,
        "Tipo C": 60,
        "Tipo D": 20,
        "Tipo E": 142,
        "Tipo F": 0,
        "Tipo G": 5,
        "Tipo H": 90,
      },
    };

    this.props.waitingCanva(false);
    //console.log("p:", this.props.proyecto);
    let availability = [];
    this.props.proyecto.Etapas.forEach((etapa) => {
      etapa.Torres.forEach((torre) => {
        availability[torre.Nombre] = [];

        torre.AptosTipo.forEach((aptoTipo) => {
          availability[torre.Nombre].push({
            tipo: aptoTipo.Categoria,
            t: torre.Nombre,
            a: aptoTipo,
          });
        });
        this.bubblesRef.current.UpdateAvailability(
          availability[torre.Nombre],
          torre.Nombre
        );
      });
    });

    this.LoadGeneralViewOrbit();
  }

  handleBackButton = () => {
    //console.log('devuelvase');

    this.props.isSideBarHomeCanva(true);
    this.props.isVisitaMapCanva(false);
    this.props.showedMapCanva("");
    this.props.selectedAptoTipoCanva({});
    this.props.aptotipoOpenedCanva(false);
    this.props.openGaleriaCanva(false);
    this.props.open360Canva(false);
    this.props.selectedPOICanva({});
    this.props.is180Canva(false);
    this.props.showGeneralViewCanva(true);
    this.props.isImage360Canva(false);
    this.props.showBillboardsCanva(false);
    this.props.categoryFilterCanva("");
    this.props.torreFilterCanva("");
    this.props.aptoFilterCanva("");
    this.props.showBubblesCanva(false);
    this.props.btnSelectedCanva("none");
    this.props.isAmenidadesCanva(false);
    this.props.isEtapasCanva(false);
    this.props.isZonasInteresCanva(false);
    this.props.isViasCanva(false);
    this.props.selectedAptoCanva("");
    this.props.selectedNumeroAptoCanva("");
    this.props.btnSelected2Canva("General View");
    this.props.hasVideoCanva(false);

    this.LoadGeneralViewOrbit();
  };

  /* CONTROLADOR DE FUNCIONES PARA EL MENU GENERAL */
  handleControlMenu = (slug, name) => {
    //console.log(this['handleControlMenu'])

    if (slug === "ViasAcceso") {
      this.handleAbrirViasDeAcceso({ mapa: "vias-map" });
    } else if (slug === "ZonasInteres") {
      this.handleAbrirZonasDeInteres();
    } else if (slug === "Amenidades") {
      this.handleAbrirAmenidades();
    } else if (slug === "Etapas") {
      this.handleAbrirEtapas();
    } else {
      this.props.btnSelectedCanva("none");
    }

    this.setState({ menu1: name });

    window.paramsObj = {
      "section-hierarchy": name,
      "section-plain": name,
    };

    window.ym(85039375, "params", window.paramsObj || {});
  };

  /*Primeros botones de la barra*/
  handleAbrirViasDeAcceso = (payload) => {
    let { nombre, mapa } = payload;

    this.props.isVisitaMapCanva(true);

    this.props.selectedZonaInteresCanva([]);
    this.props.isAmenidadesCanva(false);
    this.props.isEtapasCanva(false);
    this.props.isZonasInteresCanva(false);
    this.props.isViasCanva(true);
    this.props.showBubblesCanva(false);
    this.props.animateCanva(false);
    this.props.showedMapCanva(mapa);
    this.props.showBillboardsCanva(false);
    this.props.btnSelectedCanva("ViasAcceso");
    this.props.hasVideoCanva(false);
  };

  handleAbrirZonasDeInteres = () => {
    this.props.isSideBarHomeCanva(true);
    this.props.isVisitaMapCanva(true);
    this.props.showBillboardsCanva(false);
    this.props.btnSelectedCanva("ZonasInteres");
    this.props.showBubblesCanva(false);
    this.props.isAmenidadesCanva(false);
    this.props.isEtapasCanva(false);
    this.props.isZonasInteresCanva(true);
    this.props.isViasCanva(false);

    //Abrir el primero por defecto
    //this.handleShowZonaInteres({ nombre: "Salud", mapa: "salud-map" });
  };

  handleAbrirAmenidades = () => {
    this.props.isVisitaMapCanva(false);
    this.props.isSideBarHomeCanva(true);
    this.props.selectedAptoTipoCanva({});
    this.props.selectedNumeroAptoCanva("");
    this.props.aptotipoOpenedCanva(false);
    this.props.selectedPOICanva({});
    this.props.amenityCanva({});
    this.props.showGeneralViewCanva(true);
    this.props.showBubblesCanva(false);
    this.props.btnSelectedCanva("Amenidades");
    this.props.isAmenidadesCanva(true);
    this.props.isEtapasCanva(false);
    this.props.isZonasInteresCanva(false);
    this.props.isViasCanva(false);
    this.props.hasVideoCanva(false);
  };

  handleAbrirEtapas = () => {
    this.props.selectedPOICanva({});
    this.props.isVisitaMapCanva(false);
    this.props.selectedTorreCanva(-1);
    this.props.aptotipoOpenedCanva(false);
    this.props.showGeneralViewCanva(true);
    this.props.isImage360Canva(false);
    this.props.showBubblesCanva(false);
    this.props.categoryFilterCanva("");
    this.props.torreFilterCanva("");
    this.props.aptoFilterCanva("");
    this.props.showBillboardsCanva(false);
    this.props.linksCanva(ContextLoader["General View"]());
    this.props.isSideBarHomeCanva(true);
    this.props.isVisitaMapCanva(false);
    this.props.showedMapCanva("");
    this.props.selectedAptoTipoCanva({});
    this.props.selectedNumeroAptoCanva("");
    this.props.aptotipoOpenedCanva(false);
    this.props.openGaleriaCanva(false);
    this.props.open360Canva(false);
    this.props.selectedPOICanva({});
    this.props.is180Canva(false);
    this.props.showGeneralViewCanva(true);
    this.props.isImage360Canva(false);
    this.props.showBillboardsCanva(false);
    this.props.categoryFilterCanva("");
    this.props.torreFilterCanva("");
    this.props.aptoFilterCanva("");
    this.props.isEtapasCanva(true);
    this.props.btnSelectedCanva("Etapas");
    this.props.hasVideoCanva(false);
    this.props.openVideoCanva(false);

    //this.handleShowTorre({ index: "Sector - 1", nombre: "Sector - 1" })

    // getProyectos().then(res => {
    //     //this.setState({image: res.data.i})
    //     console.log(res.data)
    // })
  };

  /*fin Primeros botones de la barra*/

  handleShowAmenidad = (payload) => {
    let { proyecto } = this.props;
    let { nombre } = payload;

    //neccesito un payload aca, yeeii
    this.props.openGaleriaCanva(false);
    this.props.open360Canva(false);
    this.props.isImage360Canva(false);
    this.props.showBillboardsCanva(true);
    this.props.amenityCanva({ nombre: nombre, icono: payload.icono });
    this.setState({
      btnSelected: nombre,
      showTowerBillboards: false,
    });

    // var functions = {
    //     "Lobby": ContextLoader.Lobby,
    // };

    proyecto.Amenidades.forEach((element) => {
      /*pre: los nombres del AmenidadesButton deben ser los mismos de la Amenidad en la BD*/
      if (element.Nombre === nombre) {
        this.props.selectedPOICanva(element);
      } else {
        return;
      }

      // amenidades con recorrido 360:
      // TODO: agregar recorridos 360 a contenido en administración para hacer una solución general
      if (nombre === "Piscina Río Lento" || nombre === "Terraza Comunal") {
        this.props.open360Canva(true);
        return;
      }

      if (ContextLoader.hasOwnProperty(nombre)) {
        const ls = ContextLoader[nombre]();
        //console.log(ls.length)
        if (ls.length > 0) {
          if (ls.length < 36) {
            if (ls[0].indexOf("360") === -1) {
              this.props.linksCanva(null);
              this.props.is180Canva(false);
              this.props.showGeneralViewCanva(true);
              this.props.isImage360Canva(false);
              this.props.loadingCanva(true);
              this.setState(
                {
                  shouldRotate: true,
                },
                () => {
                  //console.log("back to general and showing image")
                }
              );
              //this.handleShowGaleria()
            } else {
              // is 360
              this.props.linksCanva(ls);

              this.props.is180Canva(ls.length === 36);
              this.props.showGeneralViewCanva(true);
              this.props.isImage360Canva(ls.length === 2);
              this.props.loadingCanva(true);
              this.setState(
                {
                  shouldRotate: true,
                },
                () => {
                  //1. vayase a un sitio especifico del orbit
                  if (ContextTransitions.hasOwnProperty(nombre)) {
                    var origenTransicionIndex = ContextTransitions[nombre];
                    this.props.linkTransitionCanva(null);
                    this.props.initFramePOICanva(
                      origenTransicionIndex.initFrame
                    );
                    this.props.isPreTransitionCanva(true);
                    this.handleEndTransicion();
                    this.setState({
                      initFrame180: origenTransicionIndex.init180,
                    });

                    //rotateTo(origenTransicionIndex)
                  }
                }
              );
            }
          } else {
            this.props.linksCanva(ls);
            this.props.is180Canva(ls.length === 36);
            this.props.showGeneralViewCanva(false);
            this.props.loadingCanva(true);
            this.setState(
              {
                links: ls,
                shouldRotate: true,
              },
              () => {
                //console.log("LINKS LENGTH: ", this.props.isPreTransition, origenTransicionIndex.initFrame)
                //1. vayase a un sitio especifico del orbit
                if (ContextTransitions.hasOwnProperty(nombre)) {
                  var origenTransicionIndex = ContextTransitions[nombre];

                  //var vid = origenTransicionIndex.importTransition();
                  this.props.linkTransitionCanva(null);
                  this.props.initFramePOICanva(origenTransicionIndex.initFrame);
                  this.props.isPreTransitionCanva(true);

                  this.setState({
                    initFrame180: 0,
                    bubbleAngle: origenTransicionIndex.initFrame,
                  });

                  this.props.rotateForBubbleCanva(true);
                }
              }
            );
            //console.log(this.props.links)
          }
        } else {
          // no files
          //this.props.linksCanva(ContextLoader["General View"]());
          this.props.is180Canva(false);
          this.props.showGeneralViewCanva(true);
          this.props.isImage360Canva(false);
          this.setState(
            {
              shouldRotate: false,
            },
            () => {
              //console.log("LINKS LENGTH: ", this.props.isPreTransition, origenTransicionIndex.initFrame)
              //1. vayase a un sitio especifico del orbit
              if (ContextTransitions.hasOwnProperty(nombre)) {
                var origenTransicionIndex = ContextTransitions[nombre];

                //var vid = origenTransicionIndex.importTransition();
                //this.props.linkTransitionCanva(null);
                this.props.initFramePOICanva(origenTransicionIndex.initFrame);
                this.props.isPreTransitionCanva(true);

                this.setState({
                  bubbleAngle: origenTransicionIndex.initFrame,
                });
              }
            }
          );
        }
      }
      //this.handleLoadFramesLobby();
    });
  };

  handleIsTipoAptoToSend = (payload) => {
    let { nombre } = payload;
    let b = false;

    this.props.tiposAptosCotizados.forEach((element) => {
      if (element.Nombre === nombre) {
        b = true;
      }
    });

    return b;
  };

  handleShowZonaInteres = (payload) => {
    let { nombre, mapa } = payload;

    this.props.proyecto.PuntosDeInteres.forEach((element) => {
      if (nombre === element.nombre) {
        this.props.selectedZonaInteresCanva(element);
        this.props.animateCanva(false);
      }
    });

    this.props.showedMapCanva(mapa);
    this.props.btnSelected2Canva(mapa);

    window.paramsObj = {
      "section-hierarchy": {
        [this.state.menu1]: nombre,
      },
      "section-plain": this.state.menu1 + ">" + nombre,
    };

    window.ym(85039375, "params", window.paramsObj || {});
  };

  handleShowTorre = (payload) => {
    // condición
    /* if (payload.nombre === "Torre 2" || payload.nombre === "Torre 3") {
      return;
    } */

    this.props.selectedTorreCanva(payload.index);
    this.props.selectedAptoTipoCanva({});
    this.props.selectedAptoCanva({});
    this.props.selectedNumeroAptoCanva("");
    this.props.selectedFloorCanva(-1);
    this.props.selectedPOICanva({});
    this.props.showBubblesCanva(false);
    this.props.categoryFilterCanva("");
    this.props.torreFilterCanva(payload.nombre);
    this.props.aptoFilterCanva("");
    this.props.cameraAngleCanva(0);

    this.setState({
      torreOpened: false,
      menu2: payload.nombre,
    });

    let { nombre } = payload;

    window.paramsObj = {
      "section-hierarchy": {
        [this.state.menu1]: nombre,
      },
      "section-plain": this.state.menu1 + ">" + nombre,
    };

    window.ym(85039375, "params", window.paramsObj || {});

    if (ContextLoader.hasOwnProperty(payload.nombre)) {
      const ls = ContextLoader[payload.nombre]();
      if (ls.length > 0) {
        this.props.linksCanva(ls);
        this.props.is180Canva(ls.length === 36);
        this.props.showGeneralViewCanva(true);
        this.props.isImage360Canva(false);
        this.props.towerTransitionCanva(true);
        this.setState(
          {
            links: ls,
            shouldRotate: false,
          },
          () => {
            //console.log("LINKS LENGTH: ", ls.length, payload.nombre, ls)
            //1. vayase a un sitio especifico del orbit
            if (ContextTransitions.hasOwnProperty(payload.nombre)) {
              var origenTransicionIndex = ContextTransitions[payload.nombre];

              this.props.initFramePOICanva(origenTransicionIndex.initFrame);
              //this.props.isPreTransitionCanva(true);
              this.handleEndTransicion();
            }
          }
        );
      }
    }
  };

  handleContractTorre = () => {
    this.props.selectedTorreCanva(-1);
    this.props.torreFilterCanva("");
    this.props.aptoFilterCanva("");
    this.props.selectedAptoCanva("");
    this.props.selectedNumeroAptoCanva("");

    this.setState({
      torreOpened: false,
    });
  };

  /*Boton del apto tipo en la lista de torre*/
  handleShowAptoTipo = (payload) => {
    let angle = 0;
    //if(this.props.torreFilter === 'Torre Central'){
    /*if (
      payload.aptoTipo.Categoria === "Tipo A" ||
      payload.aptoTipo.Categoria === "Apto 04"
    ) {
      angle = 54;
    } else if (
      payload.aptoTipo.Categoria === "Apto 02" ||
      payload.aptoTipo.Categoria === "Apto 03"
    ) {
      angle = 54;
    }*/

    //}

    let { aptoTipo, index } = payload;

    this.props.selectedAptoTipoCanva(aptoTipo);
    this.props.selectedNumeroAptoCanva(""); // HERE
    this.props.indexAptoTipoCanva(index);
    this.props.aptotipoOpenedCanva(true);
    this.props.selectedPOICanva(aptoTipo);
    this.props.categoryFilterCanva(aptoTipo.Categoria);
    this.props.aptoFilterCanva("");
    //this.props.rotateForBubbleCanva(true);
    /*this.setState({
      bubbleAngle: angle,
    });*/
  };

  handleContractAptoTipo = () => {
    this.props.selectedAptoTipoCanva("");
    this.props.selectedNumeroAptoCanva("");
    this.props.indexAptoTipoCanva(-1);
    this.props.selectedPOICanva("");
    this.props.categoryFilterCanva("");
    this.props.aptoFilterCanva("");
  };

  handleExpandAptoTipo = (payload) => {
    let angle = 0;

    /*if (
      payload.aptoTipo.Categoria === "Apto 01" ||
      payload.aptoTipo.Categoria === "Apto 04"
    ) {
      angle = 18;
    } else if (
      payload.aptoTipo.Categoria === "Apto 02" ||
      payload.aptoTipo.Categoria === "Apto 03"
    ) {
      angle = 54;
    }*/
    // this.handleLoadFramesAptosTipo({nombre:payload.tipoApto.Nombre})

    this.props.selectedAptoTipoCanva(payload.tipoApto);
    this.props.selectedNumeroAptoCanva("");
    this.props.aptotipoOpenedCanva(true);
    this.props.selectedPOICanva(payload.tipoApto);
    this.props.categoryFilterCanva(payload.tipoApto.Categoria);
    //this.props.rotateForBubbleCanva(true);

    /*this.setState({
      bubbleAngle: angle,
    });*/
  };

  /*el back btn del Aptos Tipo*/
  handleReturnToTorres = () => {
    //console.log('back to torres')

    this.props.selectedAptoTipoCanva({});
    this.props.selectedNumeroAptoCanva("");
    this.props.aptotipoOpenedCanva(false);
    this.props.openGaleriaCanva(false);
    this.props.open360Canva(false);
    this.props.selectedPOICanva({});
    this.props.categoryFilterCanva("");
    this.props.aptoFilterCanva("");
  };

  handleSeleccionarApto = (payload) => {
    console.log("apto", payload);

    let angle =
      this.towerBubbleAngles[this.props.selectedTorre][
        payload.aptoTipo.Categoria
      ] || 0;

    // TODO: improve algorithm to find shorter path while searching for bubbles, it was made for 4 specific angles, fails often

    /*if (payload.apto.Numero % 2 !== 0){
      angle = 86
    }*/

    //console.log('apto num:', angle)
    this.props.selectedPOICanva(payload.aptoTipo);
    this.props.categoryFilterCanva(payload.aptoTipo.Categoria);
    this.props.aptoFilterCanva(payload.aptoTipo);
    this.props.rotateForBubbleCanva(true);
    this.props.selectedAptoCanva(payload.aptoTipo);
    this.props.bubbleAngleCanva(angle);
    this.props.selectedNumeroAptoCanva(payload.aptoTipo.Nombre);
    /*this.setState({
      //bubbleAngle: angle,
      //selectedApto: payload.aptoTipo,
      //selectedNumeroApto: payload.aptoTipo.Nombre
    });*/

    window.paramsObj = {
      "section-hierarchy": {
        [this.state.menu2]: payload.aptoTipo.Nombre,
      },
      "section-plain":
        this.state.menu1 +
        ">" +
        this.state.menu2 +
        ">" +
        payload.aptoTipo.Nombre,
    };

    window.ym(85039375, "params", window.paramsObj || {});
  };

  handleSelectFloor = (payload) => {
    this.props.selectedFloorCanva(payload);
    this.props.aptoFilterCanva("");
    this.props.proyecto.Amenidades.map((amenidad) => {
      if (amenidad.Nombre === "Piso " + payload) {
        this.props.selectedPOICanva(amenidad);
      }
    });
  };

  handleDeselectFloor = (payload) => {
    this.props.selectedPOICanva("");
    this.props.selectedFloorCanva(-1);
    this.props.aptoFilterCanva("");
    /*this.setState({
      selectedApto: "",
      torreOpened: true,
    })
    this.handleShowTorre({"nombre":"Torre 1","angle":bubbleAngle})*/
  };

  handleBubbleClick = (apto) => {
    /*console.log('bubble click:', apto)
        if((isAmenidades || isEtapas) && 
            ((apto.Planos && apto.Planos.length > 0) || 
            (apto.Galeria && apto.Galeria.length > 0))
            )
        {
            this.setState(prevstate => ({
                selectedAptoTipo: apto,
                selectedPOI: apto
            }),
            () => {
                this.handleShowGaleria();
            })  
        }*/
  };

  handleShowGaleria = () => {
    this.props.openGaleriaCanva(true);
    this.props.open360Canva(false);
  };

  handleShowRecorridos360 = () => {
    this.props.openGaleriaCanva(false);
    this.props.open360Canva(true);
  };

  /*mail: deprecated*/
  handleAddTipoAptoCotizador = (payload) => {};

  handleUnselectAptoTipo = (payload) => {
    let { nombreAptoTipo, index } = payload;
    let { tiposAptosCotizados } = this.props;

    const arr1 = tiposAptosCotizados.slice(0, index);
    const arr2 = tiposAptosCotizados.slice(
      index + 1,
      tiposAptosCotizados.length
    );
    this.setState({ tiposAptosCotizados: [...arr1, ...arr2] });
  };

  handleLoadFramesAptosTipo = (payload) => {
    let { nombre } = payload;

    //console.log('muestra el apto tipo', nombre);

    this.props.btnSelectedCanva(nombre);

    if (ContextLoader.hasOwnProperty(nombre)) {
      const ls = ContextLoader[nombre]();
      this.props.linksCanva(ls);
    }
  };

  LoadGeneralViewOrbit = () => {
    if (!this.props.isAmenidades) {
      this.props.proyecto.Amenidades.map((Amenidad) =>
        Amenidad.Nombre === "General View"
          ? this.props.selectedPOICanva(Amenidad)
          : this.props.selectedPOICanva({})
      );
    }
    if (ContextLoader.hasOwnProperty("General View")) {
      const ls = ContextLoader["General View"]();
      this.props.linksCanva(ls);
      this.props.is180Canva(ls.length === 36);
      this.setState({
        shouldRotate: false,
      });
    }
  };

  handleStartTransicion = () => {
    this.handleEndTransicion();
    /*
        if(this.props.is180 || this.props.isImage360){
            this.props.towerTransitionCanva(false);
            this.setState({
                isTransicion: true,
            });
            
        } else if(this.props.towerTransition){
            this.setState({
                isTransicion: true
            });
        }*/
  };

  handleEndTransicion = () => {
    if (this.props.towerTransition) {
      this.props.isPreTransitionCanva(false);
      this.props.showGeneralViewCanva(false);
      this.props.showBubblesCanva(false);
      this.props.towerTransitionCanva(false);
      this.props.loadingCanva(true);
    } else {
      this.props.isPreTransitionCanva(false);

      // WARNING THESE LINES ARE NECESSARY (TO SHOW SECONDARY CAMERA) IF THERE ARE AMENITIES SPINS
      //this.props.showGeneralViewCanva(false);
      //this.props.loadingCanva(true);
    }
  };

  handleSecondaryCameraAngleUpdate = (angle) => {
    this.props.cameraAngleCanva(angle);
    /*this.setState({
      cameraAngle: angle,
    });*/
  };
  handleMainCameraAngleUpdate = (angle) => {
    this.props.mainCameraAngleCanva(angle);
    /*this.setState({
      mainCameraAngle: angle,
    });*/
  };

  /*Aptos instead of aptosTipo*/
  /*mail*/
  handleAddAptoCotizador = (payload) => {
    let apto = payload;
    let { textures, tiposAptosCotizados, aptosCotizados } = this.props;
    //console.log('agregalo a la lista');

    //verifique si ya está. si no esta es -1
    // let index = tiposAptosCotizados.findIndex(ta => ta.Nombre === tipoApto.Nombre);

    let index = aptosCotizados.findIndex((a) => a.Nombre === apto.Nombre);

    //console.log('index apto cotizado a agregar', index)
    //console.log('apto to add', payload)
    //console.log('textures:',textures)

    if (index === -1 && aptosCotizados.length === 0) {
      //Obj momentaneo del apto: numero, tipoapto, areas y plano
      let sel = {};
      sel.Nombre = apto.Nombre;
      sel.TipoApto = apto.Nombre;
      sel.Areas = [];
      apto.Areas.forEach((element) => {
        sel.Areas = [
          ...sel.Areas,
          { Tipo: element.Nombre, Area: element.Valor },
        ];
      });

      //agregue las imagenes. Como un link? YEP ^^
      // TODO: Use the Planos property to store Blueprints!
      /*sel.Plano = apto.Galeria[apto.Galeria.length - 1]
        ? textures[`Images/Planos/${apto.Planos[0].Imagen}`]
        : textures[`logo_default_mail.jpg`]; //pre, que sea mayor a 200px la imagen dle logo*/

      sel.Plano = apto.Galeria[apto.Galeria.length - 1]
        ? textures[apto.Galeria[apto.Galeria.length - 1].Imagen]
        : textures[`logo_default_mail.jpg`]; //pre, que sea mayor a 200px la imagen dle logo*/

      this.props.aptosCotizadosCanva([...aptosCotizados, sel]);
      this.props.isFormCotizacionCanva(true);
    } else {
      alert("Ya hay un tipo de apto seleccionado para cotizar.");
    }
  };

  handleIsAptoToSend = (payload) => {
    let { nombre } = payload;
    let b = false;
    let { tiposAptosCotizados, aptosCotizados } = this.props;

    aptosCotizados.forEach((element) => {
      if (element.Nombre === nombre) {
        b = true;
      }
    });

    //un handle si deja retornar o solo this.state... ? //sii!
    return b;
  };

  /***  */
  handleUnselectApto = (payload) => {
    let { nombreAptoTipo, index, numeroApto } = payload;
    let { tiposAptosCotizados, aptosCotizados } = this.props;
    //console.log('elimina de los seleccionados', numeroApto)

    const arr1 = aptosCotizados.slice(0, index);
    const arr2 = aptosCotizados.slice(index + 1, aptosCotizados.length);
    this.props.aptosCotizadosCanva([...arr1, ...arr2]);
  };

  handleUnselectAptoFindIndex = (payload) => {
    let { nombreApto } = payload;
    let { aptosCotizados } = this.props;
    //console.log('elimina de los seleccionados', numeroApto)
    let index = -1;

    aptosCotizados.forEach((element, i) => {
      if (element.Nombre === nombreApto) {
        index = i;
      }
    });
    //no debe entrar con el -1 pues no hubiera entrado a este metodo si no estuviera en la lista a enviar
    this.handleUnselectApto({ index: index, nombreApto: nombreApto });
  };

  handleSendFormCotizacion = (event) => {
    let name = event.target.textName.value;
    let email = event.target.textEmail.value;
    let phone = event.target.textPhone.value;
    let { aptosCotizados, proyecto } = this.props;
    console.log(proyecto);

    createEmail({ name, email, phone, aptosCotizados, proyecto }).then(
      (res) => {
        //console.log('Mail de cotizacion creado', res);
      }
    );

    //separado por si son Modulos distintos
    insertCotizacion({ name, email, phone, aptosCotizados, proyecto }).then(
      (res) => {
        //console.log('Cotizacion insertada', res);
      }
    );
  };

  on360Ready = () => {
    this.props.loadingCanva(false);
    this.props.isTransicionCanva(false);
  };

  onReadyTorres = () => {
    //console.log('ready torres')
    if (this.props.isEtapas) {
      this.props.showBubblesCanva(true);
      this.props.isTransicionCanva(false);
      this.props.loadingCanva(false);
    } else {
      this.props.isTransicionCanva(false);
      this.props.loadingCanva(false);
    }
  };

  /* generalOrbitReady = () => {
    this.setState({
      loading: false,
    });
  }; */

  handleBubbleOpen360 = (data) => {
    this.props.openGaleriaCanva(false);
    this.props.open360Canva(true);
    this.props.selectedPOICanva({ Nombre: data });
  };

  handleBubbleOpenGallery = (data) => {
    this.props.selectedAptoTipoCanva(data); // TODO: check why gallery component is using two variables to store the same data :facepalm:
    this.props.selectedPOICanva(data);
    this.handleShowGaleria();
  };

  changeAnimate = (params) => {
    this.props.animateCanva(params);
  };

  updateFromTourData = (payload) => {
    if (payload) {
      if (
        this.props.showGeneralView &&
        payload.mainCameraAngle &&
        !this.props.is180
      ) {
        this.mainCameraRef.current.updateFromTourData(payload.mainCameraAngle);
      }

      if (
        (payload.cameraAngle &&
          !this.props.showGeneralView &&
          !this.props.isImage360) ||
        this.props.is180
      ) {
        if (this.secondaryCameraRef.current) {
          this.secondaryCameraRef.current.updateFromTourData(
            payload.cameraAngle
          );
        }
      }

      if (this.mapRef && payload.mapZoom && payload.mapCenter) {
        this.mapRef.updateMap(payload.mapCenter, payload.mapZoom);
      }

      if (this.galleryRef.current && payload.openGaleria) {
        this.galleryRef.current.updateGalleryFromTour(payload.galleryIndex);
      }

      if (this.viewer360ref.current && payload.direction) {
        this.viewer360ref.current.updateDirectionFromTour(payload.direction);
      }

      console.log("updated to:", payload);
      this.props.fullUpdate({ ...payload });

      //console.log('new props: ', this.props)
    }
  };

  updateMapDataTour = (payload) => {
    this.setState({
      mapCenter: payload.mapCenter,
      mapZoom: payload.mapZoom,
    });
  };

  update360Tour = (payload) => {
    console.log("update360Tour:", payload);
    this.setState({
      direction: payload,
    });
  };

  updateGalleryTour = (index) => {
    this.setState({
      galleryIndex: index,
    });
  };

  setControlLock = (locked) => {
    console.log("locked:", locked);
    this.setState({
      lockedControl: locked,
    });
  };

  updateHasControl = (hasControl) => {
    this.setState({
      hasControl: hasControl,
    });
  };

  notifyZoomAndOffsets = (zoom, leftOffset, topOffset) => {
    this.setState({
      zoom: zoom,
      leftOffset: leftOffset,
      topOffset: topOffset,
    });
  };

  handleShowVideo = () => {
    //console.log(this.state.currentVideo)
    this.props.openVideoCanva(true);
    /*this.setState({
      openVideo: true
    })*/
  };

  handleCloseVideo = () => {
    //console.log(this.state.currentVideo)
    this.props.openVideoCanva(false);
    /*this.setState({
      openVideo: false
    })*/
  };

  render() {
    let {
      loading,
      waitingForData,
      barHidden,
      isSidebarHome,
      isVistaMap,
      proyecto,
      textures,
      showedMap,
      selectedTorre,
      selectedAptoTipo,
      selectedNumeroApto,
      selectedAptos,
      selectedFloor,
      aptotipoOpened,
      openGaleria,
      open360,
      selectedPOI,
      isFormCotizacion,
      links,
      linkTransition,
      isTransicion,
      initFramePOI,
      isPreTransition,
      aptosCotizados,
      is180,
      showGeneralView,
      isImage360,
      showBubbles,
      showBillboards,
      categoryFilter,
      torreFilter,
      aptoFilter,
      amenity,
      showingTorresSpin,
      towerTransition,
      rotateForBubble,
      selectedZonaInteres,

      mainCameraAngle,
      btnSelected,
      isAmenidades,
      isEtapas,
      isZonasInteres,
      isVias,
      selectedApto,
      initFrame180,
      bubbleAngle,
      cameraAngle,
      animate,
      isPlano,
      btnSelected2,

      hasVideo,
      openVideo,
      currentVideo,
      tiposAptosCotizados,
    } = this.props;
    return (
      <div className="maqueta-page">
        {isPreTransition || isTransicion || this.state.lockedControl ? (
          <div className="rect-disabler"></div>
        ) : (
          <div></div>
        )}

        <GuidedTour
          mainCameraAngle={mainCameraAngle}
          updateFromTourData={this.updateFromTourData}
          updateHasControl={this.updateHasControl}
          loading={loading}
          waitingForData={waitingForData}
          barHidden={barHidden}
          isSidebarHome={isSidebarHome}
          isVistaMap={isVistaMap}
          //proyecto={proyecto}
          //textures={textures}
          showedMap={showedMap}
          selectedTorre={selectedTorre}
          selectedAptoTipo={selectedAptoTipo}
          selectedAptos={selectedAptos}
          selectedNumeroApto={selectedNumeroApto}
          selectedFloor={selectedFloor}
          aptotipoOpened={aptotipoOpened}
          openGaleria={openGaleria}
          open360={open360}
          selectedPOI={selectedPOI}
          isFormCotizacion={isFormCotizacion}
          links={links}
          //linkTransition={linkTransition}
          isTransicion={isTransicion}
          initFramePOI={initFramePOI}
          isPreTransition={isPreTransition}
          aptosCotizados={aptosCotizados}
          is180={is180}
          showGeneralView={showGeneralView}
          isImage360={isImage360}
          showBubbles={showBubbles}
          showBillboards={showBillboards}
          categoryFilter={categoryFilter}
          torreFilter={torreFilter}
          aptoFilter={aptoFilter}
          amenity={amenity}
          showingTorresSpin={showingTorresSpin}
          towerTransition={towerTransition}
          rotateForBubble={rotateForBubble}
          selectedZonaInteres={selectedZonaInteres}
          /*mainCameraAngle={mainCameraAngle}*/
          btnSelected={btnSelected}
          isAmenidades={isAmenidades}
          isEtapas={isEtapas}
          isZonasInteres={isZonasInteres}
          isVias={isVias}
          selectedApto={selectedApto}
          initFrame180={initFrame180}
          bubbleAngle={bubbleAngle}
          cameraAngle={cameraAngle}
          animate={animate}
          isPlano={isPlano}
          btnSelected2={btnSelected2}
          mapZoom={this.state.mapZoom}
          mapCenter={this.state.mapCenter}
          galleryIndex={this.state.galleryIndex}
          setControlLock={this.setControlLock}
          direction={this.state.direction}
          openVideo={openVideo}
          hasVideo={hasVideo}
          currentVideo={currentVideo}
        ></GuidedTour>

        <div className="sidebar" id={btnSelected}>
          <div className="header-logo">
            <img alt="" id="Logo_Proyecto" src={LogoProyecto} />
          </div>

          <div className="bar-and-hide">
            <div className={`sidebar-content ${barHidden ? "hidden" : ""}`}>
              {isSidebarHome ? (
                <div>
                  {proyecto.menus.map((item, index) => {
                    return (
                      <MenuGeneralContainer
                        key={`mapa_butt_${index}`}
                        nombre={item.nombre}
                        ico={item.ico}
                        slug={item.slug}
                        icons={icons}
                        btnSelected={btnSelected}
                        evento={() =>
                          this.handleControlMenu(item.slug, item.nombre)
                        }
                        activeBg="#fff"
                        color="#fff"
                        activeColor="#1e2a41"
                      />
                    );
                  })}
                </div>
              ) : (
                <div></div>
              )}
              {isZonasInteres ||
              isVias ||
              isAmenidades ||
              (isEtapas && torreFilter !== "") ? (
                <button className="back-btn" onClick={this.handleBackButton}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1.66667in"
                    height="1.11111in"
                    viewBox="0 0 150 100"
                  >
                    <path
                      id="Imported Path"
                      fill="none"
                      stroke="black"
                      strokeWidth="0"
                      d="M 37.62,27.00
                      C 19.62,39.00 5.00,49.50 5.38,50.38
                          6.00,52.50 67.62,93.75 70.25,93.75
                          72.25,93.75 72.50,92.50 72.50,80.38
                          72.50,80.38 72.50,67.12 72.50,67.12
                          72.50,67.12 85.50,67.88 85.50,67.88
                          114.38,69.62 124.62,74.50 139.88,93.12
                          141.25,94.88 141.88,95.00 143.25,93.50
                          145.62,91.12 143.38,77.75 139.12,68.75
                          130.62,51.12 106.63,36.88 77.25,31.88
                          77.25,31.88 72.50,31.12 72.50,31.12
                          72.50,31.12 72.50,18.75 72.50,18.75
                          72.50,12.00 72.00,6.12 71.50,5.75
                          70.88,5.37 55.62,15.00 37.62,27.00 Z"
                    />
                  </svg>
                </button>
              ) : (
                <span></span>
              )}
              {/* back de aptos a torres: */}
              {aptotipoOpened ? (
                <button
                  className="back-btn"
                  onClick={this.handleReturnToTorres}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="1.66667in"
                    height="1.11111in"
                    viewBox="0 0 150 100"
                  >
                    <path
                      id="Imported Path"
                      fill="none"
                      stroke="black"
                      strokeWidth="0"
                      d="M 37.62,27.00
                              C 19.62,39.00 5.00,49.50 5.38,50.38
                                  6.00,52.50 67.62,93.75 70.25,93.75
                                  72.25,93.75 72.50,92.50 72.50,80.38
                                  72.50,80.38 72.50,67.12 72.50,67.12
                                  72.50,67.12 85.50,67.88 85.50,67.88
                                  114.38,69.62 124.62,74.50 139.88,93.12
                                  141.25,94.88 141.88,95.00 143.25,93.50
                                  145.62,91.12 143.38,77.75 139.12,68.75
                                  130.62,51.12 106.63,36.88 77.25,31.88
                                  77.25,31.88 72.50,31.12 72.50,31.12
                                  72.50,31.12 72.50,18.75 72.50,18.75
                                  72.50,12.00 72.00,6.12 71.50,5.75
                                  70.88,5.37 55.62,15.00 37.62,27.00 Z"
                    />
                  </svg>
                </button>
              ) : (
                <span></span>
              )}
            </div>
            <button
              className="hide-btn"
              onClick={
                !barHidden
                  ? () => this.props.barHiddenCanva(true)
                  : () => this.props.barHiddenCanva(false)
              }
            >
              {
                /*disabled hide button if second bar is open*/ !isEtapas ? (
                  <img
                    className={barHidden ? "hidden-btn-img" : ""}
                    src={icons["Back simple"]}
                  />
                ) : (
                  <span></span>
                )
              }
            </button>
          </div>
        </div>

        {/* Barra secundaria */}
        {isEtapas && !openGaleria && !open360 ? (
          !aptotipoOpened ? (
            <BarEtapasPisoComponent
              proyecto={proyecto}
              selectedTorre={selectedTorre}
              handleShowTorre={this.handleShowTorre}
              handleContractTorre={this.handleContractTorre}
              handleShowAptoTipo={this.handleShowAptoTipo}
              handleSelectApto={this.handleSeleccionarApto}
              //handleSelectNumeroApto={this.handleSeleccionarNumeroApto}
              barHidden={barHidden}
              selectedFloor={selectedFloor}
              handleSelectFloor={this.handleSelectFloor}
              handleDeselectFloor={this.handleDeselectFloor}
              selectedApto={selectedApto}
              handleIsTipoAptoToSend={this.handleIsTipoAptoToSend}
              handleContractAptoTipo={this.handleContractAptoTipo}
              handleIsAptoToSend={this.handleIsAptoToSend}
              handleUnselectAptoFindIndex={this.handleUnselectAptoFindIndex}
              handleAddAptoCotizador={this.handleAddAptoCotizador}
            />
          ) : null
        ) : (
          <div className="etapas-bar-invis"></div>
        )}

        {/* Hide btn de barra secundaria */}
        {isEtapas && !openGaleria && !open360 ? (
          <button
            className={`hide-btn hide-bar-2 ${barHidden ? "hidden" : ""}`}
            onClick={
              !barHidden
                ? () => this.props.barHiddenCanva(true)
                : () => this.props.barHiddenCanva(false)
            }
          >
            <img
              className={barHidden ? "hidden-btn-img" : ""}
              src={icons["Back simple"]}
            />
          </button>
        ) : (
          <div className="etapas-bar-invis"></div>
        )}

        {/****  Canvas ******/}

        <div className="canvas-content">
          <div className="canvas-3d" id="canvas-content">
            <Camera
              useSubdirectories={false}
              links={ContextLoader["General View"]()}
              initFramePOI={initFramePOI}
              isPreTransition={isPreTransition}
              handleStartTransicion={this.handleStartTransicion}
              handleAngleUpdate={this.handleMainCameraAngleUpdate}
              onReady={() => this.props.loadingCanva(false)}
              is180={false}
              notifyZoomAndOffsets={this.notifyZoomAndOffsets}
              ref={this.mainCameraRef}
              hasControl={this.state.hasControl}
            ></Camera>

            {(!showGeneralView && !isImage360) || is180 ? (
              <div className="secondary-camera">
                <Camera
                  useSubdirectories={false}
                  links={links}
                  onReady={this.onReadyTorres}
                  initFramePOI={this.state.initFrame180}
                  is180={is180}
                  secondary={true}
                  handleAngleUpdate={this.handleSecondaryCameraAngleUpdate}
                  rotateForBubble={rotateForBubble}
                  bubbleAngle={bubbleAngle}
                  handleStartTransicion={this.handleStartTransicion}
                  notifyZoomAndOffsets={this.notifyZoomAndOffsets}
                  handleRotateForBubbleEnded={() =>
                    this.props.rotateForBubbleCanva(false)
                  }
                  ref={this.secondaryCameraRef}
                  hasControl={this.state.hasControl}
                ></Camera>
              </div>
            ) : (
              <div></div>
            )}

            {isTransicion ? (
              <Transicion
                linkTransition={linkTransition}
                handleEndTransicion={this.handleEndTransicion}
                // handleCanStartTransicion = {this.handleCanStartTransicion}
              ></Transicion>
            ) : (
              <div></div>
            )}

            {isImage360 ? (
              <Viewer360
                /* small size image for mobile */
                hasControl={this.state.hasControl}
                update360Tour={this.update360Tour}
                path={window.innerWidth > 825 ? links[0] : links[1]}
                onReady={this.on360Ready}
                ref={this.viewer360ref}
              ></Viewer360>
            ) : (
              <div></div>
            )}

            <div
              className="secondary-camera"
              style={{
                pointerEvents: "none",
              }}
            >
              <Bubbles
                ref={this.bubblesRef}
                /*availability = {this.state.availability}*/
                angle={cameraAngle}
                show={showBubbles}
                tower={torreFilter}
                category={categoryFilter}
                apto={selectedApto}
                numeroApto={selectedNumeroApto}
                onBubbleClick={this.handleBubbleClick}
                onBubble360Click={this.handleBubbleOpen360}
                onBubbleGalleryClick={this.handleBubbleOpenGallery}
                bubblesAngle={bubbleAngle}
                zoom={this.state.zoom}
                leftOffset={this.state.leftOffset}
                topOffset={this.state.topOffset}
              ></Bubbles>
            </div>

            <div className="secondary-camera" style={{ pointerEvents: "none" }}>
              <Billboards
                ref={this.billboardsRef}
                show={this.props.showBillboards}
                angle={mainCameraAngle}
                amenity={this.props.amenity}
                gallery={selectedPOI.Galeria}
                openGallery={this.handleShowGaleria}
                bubblesAngle={bubbleAngle}
                zoom={this.state.zoom}
                leftOffset={this.state.leftOffset}
                topOffset={this.state.topOffset}
              ></Billboards>
            </div>
          </div>
          {
            isVistaMap ? (
              <MapaComponent
                textures={textures}
                puntosInteres={selectedZonaInteres}
                dataProject={proyecto.Ubicacion[0]}
                showedMap={showedMap}
                animate={animate}
                changeAnimate={this.changeAnimate}
                showVias={isVias}
                notifyMapData={this.updateMapDataTour}
                childRef={(ref) => (this.mapRef = ref)}
              ></MapaComponent>
            ) : null
            // Amenidades y etapas
          }

          {/* ----- Slide de galeria ------*/}
          {openGaleria ? (
            <GaleriaComponent
              selectedAptoTipo={selectedAptoTipo}
              selectedPOI={selectedPOI}
              textures={textures}
              // handleImageLoaded = {this.handleImageLoaded}
              handleCloseGaleria={() => this.props.openGaleriaCanva(false)}
              // handlePrevGaleria = {this.handlePrevGaleria}
              // handleNextGaleria = {this.handleNextGaleria}
              updateGalleryTour={this.updateGalleryTour}
              isPlano={isPlano}
              ref={this.galleryRef}
            />
          ) : (
            <div></div>
          )}

          {/* ----- Slide de Iframe 360  ------*/}
          {open360 ? (
            <Recorrido360Component
              handleCloseRecorridos360={() => this.props.open360Canva(false)}
              tourname={selectedPOI.Nombre}
            />
          ) : (
            <div></div>
          )}

          {proyecto.Modulos.includes("DISPONIBILIDAD") && isEtapas ? (
            <div className="gizmos-dispon">
              <div>
                <img src={icons["VENDIDO"]} />
                <span>Vendido</span>
              </div>
              <div>
                <img src={icons["DISPONIBLE"]} />
                <span>Disponible</span>
              </div>
              <div>
                <img src={icons["RESERVADO"]} />
                <span>Reservado</span>
              </div>
            </div>
          ) : (
            <div className="gizmos-dispon"></div>
          )}

          {/* mail */}

          {!isFormCotizacion ? (
            <button
              className="mail-btn"
              onClick={() => this.props.isFormCotizacionCanva(true)}
              disabled={isPreTransition || isTransicion}
            >
              $ <div className="label-n-cotizados">{aptosCotizados.length}</div>
            </button>
          ) : (
            <CotizacionComponent
              tiposAptosCotizados={tiposAptosCotizados}
              aptosCotizados={aptosCotizados}
              handleCerrarCotizacion={() =>
                this.props.isFormCotizacionCanva(false)
              }
              handleUnselectAptoTipo={this.handleUnselectAptoTipo}
              handleSendFormCotizacion={this.handleSendFormCotizacion}
              handleUnselectApto={this.handleUnselectApto}
            />
          )}
        </div>

        {/* Frames Test*/}
        {/* <div>
                    <img className="div-frame" src={links && links[0]}></img>
                </div> */}

        {/* <div>
                    <img id="logo_Umbra" alt=""></img>
                </div> */}
        {loading || waitingForData ? (
          <div className="canvas-loading">
            <img className="loader-circle" src={svg_loading} />{" "}
          </div>
        ) : (
          <div></div>
        )}

        {/*Barra amenidades*/}
        {isAmenidades ? (
          <BarAmenidadesComponent
            icons={icons}
            ProyectoAmenidades={proyecto.Amenidades}
            handleClickButton={this.handleShowAmenidad}
            stateBtnSelected={btnSelected2}
          />
        ) : (
          <div className="amenidades-bar-invis"></div>
        )}

        {/*Barra Zonas de interes*/}
        {isZonasInteres ? (
          <>
            {proyecto.menus.map((item, index) => {
              return item.subMenu.length > 0 ? (
                <div className="zonasInteres-sidebar">
                  <div className="sidebar-ZonasInteres">
                    {item.subMenu.map((element, key) => {
                      return (
                        <MenuGeneralContainer
                          key={`mapa_but_${key}`}
                          nombre={element.nombre}
                          ico={element.ico}
                          slug={element.slug}
                          icons={icons}
                          btnSelected={btnSelected2}
                          evento={(event) =>
                            this.handleShowZonaInteres({
                              nombre: element.nombre,
                              mapa: element.slug,
                            })
                          }
                          activeBg="#2d3539"
                          color="#2d3539"
                          activeColor="#f5f5f5"
                        />
                      );
                    })}
                  </div>
                </div>
              ) : (
                ""
              );
            })}
          </>
        ) : (
          <div></div>
        )}

        {hasVideo ? (
          <button className={`videos-btn`} onClick={this.handleShowVideo}>
            <img src={icons["Videos"]} />
          </button>
        ) : (
          <></>
        )}

        {openVideo ? (
          <VideoComponent
            currentVideo={currentVideo}
            handleClose={this.handleCloseVideo}
          ></VideoComponent>
        ) : (
          <></>
        )}

        {(selectedAptoTipo.Planos && selectedAptoTipo.Planos.length > 0) ||
        (selectedPOI.Galeria && selectedPOI.Galeria.length > 0) ? (
          <button className={`renders-btn`} onClick={this.handleShowGaleria}>
            <img src={icons["Renders"]} />
          </button>
        ) : (
          <span></span>
        )}
        {isEtapas &&
        selectedPOI.Galeria &&
        selectedPOI.Galeria.length > 0 &&
        (selectedPOI.Categoria === "Tipo A" ||
          selectedPOI.Categoria === "Tipo D" ||
          selectedPOI.Categoria === "Tipo E") ? (
          <button
            className={`recor360-btn`}
            onClick={this.handleShowRecorridos360}
          >
            <img src={icons["360"]} />
          </button>
        ) : (
          <span></span>
        )}
        <div className="containerBar"></div>
        <div id="logo_Umbra">
          <a target="_blank" href="https://umbra3d.studio">
            <img alt="" src={LogoUmbra} />
          </a>{" "}
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ canvaReducer, welcomeReducer }) => {
  const {
    loading,
    waitingForData,
    barHidden,
    isSidebarHome,
    isVistaMap,

    showedMap,
    selectedTorre,
    selectedAptoTipo,
    selectedNumeroApto,
    indexAptoTipo,
    tiposAptosCotizados,
    selectedAptos,
    selectedFloor,

    aptotipoOpened,
    openGaleria,
    open360,
    selectedPOI,
    isFormCotizacion,

    links,
    linkTransition,
    isTransicion,
    initFramePOI,
    isPreTransition,

    aptosCotizados,

    is180,
    showGeneralView,
    isImage360,
    showBubbles,
    showBillboards,

    categoryFilter,
    torreFilter,
    aptoFilter,
    amenity,
    showingTorresSpin,
    towerTransition,

    rotateForBubble,

    selectedZonaInteres,

    mainCameraAngle,
    btnSelected,
    isAmenidades,
    isEtapas,
    isZonasInteres,
    isVias,
    selectedApto,
    initFrame180,
    bubbleAngle,
    cameraAngle,
    animate,
    isPlano,
    btnSelected2,
    hasVideo,
    openVideo,
    currentVideo,
  } = canvaReducer;
  const { proyecto, textures } = welcomeReducer;
  return {
    loading,
    waitingForData,
    barHidden,
    isSidebarHome,
    isVistaMap,
    showedMap,
    selectedTorre,
    selectedAptoTipo,
    selectedNumeroApto,
    indexAptoTipo,
    tiposAptosCotizados,
    selectedAptos,
    selectedFloor,
    aptotipoOpened,
    openGaleria,
    open360,
    selectedPOI,
    isFormCotizacion,
    links,
    linkTransition,
    isTransicion,
    initFramePOI,
    isPreTransition,
    aptosCotizados,
    is180,
    showGeneralView,
    isImage360,
    showBubbles,
    showBillboards,
    categoryFilter,
    torreFilter,
    aptoFilter,
    amenity,
    showingTorresSpin,
    towerTransition,
    rotateForBubble,
    selectedZonaInteres,

    mainCameraAngle,
    btnSelected,
    isAmenidades,
    isEtapas,
    isZonasInteres,
    isVias,
    selectedApto,
    initFrame180,
    bubbleAngle,
    cameraAngle,
    animate,
    isPlano,
    btnSelected2,
    hasVideo,
    openVideo,
    currentVideo,

    proyecto,
    textures,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    initialProyectosWelcome,
    loadingCanva,
    waitingCanva,
    barHiddenCanva,
    isSideBarHomeCanva,
    isVisitaMapCanva,
    showedMapCanva,
    selectedTorreCanva,
    selectedAptoTipoCanva,
    selectedNumeroAptoCanva,
    indexAptoTipoCanva,
    tiposAptosCotizadosCanva,
    selectedAptosCanva,
    selectedFloorCanva,
    aptotipoOpenedCanva,
    openGaleriaCanva,
    open360Canva,
    selectedPOICanva,
    isFormCotizacionCanva,
    linksCanva,
    linkTransitionCanva,
    isTransicionCanva,
    initFramePOICanva,
    isPreTransitionCanva,
    aptosCotizadosCanva,
    is180Canva,
    showGeneralViewCanva,
    isImage360Canva,
    showBubblesCanva,
    showBillboardsCanva,
    categoryFilterCanva,
    torreFilterCanva,
    aptoFilterCanva,
    amenityCanva,
    showingTorresSpinCanva,
    towerTransitionCanva,
    rotateForBubbleCanva,
    selectedZonaInteresCanva,

    mainCameraAngleCanva,
    btnSelectedCanva,
    isAmenidadesCanva,
    isEtapasCanva,
    isZonasInteresCanva,
    isViasCanva,
    selectedAptoCanva,
    initFrame180Canva,
    bubbleAngleCanva,
    cameraAngleCanva,
    animateCanva,
    isPlanoCanva,
    btnSelected2Canva,
    hasVideoCanva,
    openVideoCanva,
    currentVideoCanva,

    fullUpdate,
  })(Canvas)
);
